var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLineClose = function SvgIconLineClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.043 4.543 1.414 1.414L13.414 12l6.043 6.043-1.414 1.414L12 13.414l-6.043 6.043-1.414-1.414L10.586 12 4.543 5.957l1.414-1.414L12 10.586z"
  })));
};
export { SvgIconLineClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjA0MyA0LjU0Mjk3TDE5LjQ1NzIgNS45NTcxOEwxMy40MTQgMTJMMTkuNDU3MiAxOC4wNDNMMTguMDQzIDE5LjQ1NzJMMTIgMTMuNDE0TDUuOTU3MTggMTkuNDU3Mkw0LjU0Mjk3IDE4LjA0M0wxMC41ODYgMTJMNC41NDI5NyA1Ljk1NzE4TDUuOTU3MTggNC41NDI5N0wxMiAxMC41ODZMMTguMDQzIDQuNTQyOTdaIi8+Cjwvc3ZnPgo=";